// Profile picture generation logic using OpenAI API via backend
import api from '../../../services/api';

export const generateProfilePicture = async (imageFile, personalization = {}) => {
  try {
    // Create original image URL for before/after comparison
    const originalImageUrl = URL.createObjectURL(imageFile);
    
    // Create form data to send the image and personalization options
    const formData = new FormData();
    formData.append('image', imageFile);
    
    // Add personalization options only if they have values
    if (personalization.expression) {
      formData.append('expression', personalization.expression);
    }
    if (personalization.presence) {
      formData.append('presence', personalization.presence);
    }
    if (personalization.attire) {
      formData.append('attire', personalization.attire);
    }
    if (personalization.professional_context) {
      formData.append('professional_context', personalization.professional_context);
    }
    if (personalization.background) {
      formData.append('background', personalization.background);
    }
    if (personalization.lighting) {
      formData.append('lighting', personalization.lighting);
    }
    if (personalization.finish) {
      formData.append('finish', personalization.finish);
    }
    if (personalization.pose) {
      formData.append('pose', personalization.pose);
    }
    if (personalization.framing) {
      formData.append('framing', personalization.framing);
    }

    const response = await api.post(
      '/api/generate-profile-picture',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 120000, // 2 minute timeout for image generation
      }
    );

    return {
      imageUrl: response.data.image_url,
      originalImageUrl: originalImageUrl,
    };
  } catch (error) {
    console.error('Error generating profile picture:', error);
    
    // Handle specific error codes
    if (error.response?.status === 401) {
      throw new Error('AUTH_REQUIRED');
    }
    if (error.response?.status === 402) {
      throw new Error('INSUFFICIENT_CREDITS');
    }
    
    throw new Error(
      error.response?.data?.detail || 'Failed to generate profile picture. Please try again.'
    );
  }
};
